// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log("Vite ⚡️ Rails");

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  "Visit the guide for more information: ",
  "https://vite-ruby.netlify.app/guide/rails"
);

console.log("Application.js located");

// Example: Load Rails libraries in Vite.

import $ from "jquery"; // Import jQuery
import "jquery-ujs"; // Import Rails UJS (AJAX, CSRF support)
import "jquery-ui";

import "react-datepicker/dist/react-datepicker.css";

// import JsRoutes from '@jsroutes';
import Routes from "./routesWrapper.js";
import "~/entrypoints/scripts/array_functions.js";
import "~/entrypoints/scripts/cable.js";
import "~/entrypoints/scripts/check_days.js";
import "~/entrypoints/scripts/conflict_remove.js";
import "~/entrypoints/scripts/content_position.js";

// import "~/entrypoints/stylesheets/uswds.scss";
import "~/entrypoints/stylesheets/application.css";
import "~/entrypoints/stylesheets/application.scss";
import "~/entrypoints/stylesheets/atty_columns.css";
import "~/entrypoints/stylesheets/atty_selector.scss";
import "~/entrypoints/stylesheets/calendar.css";
import "~/entrypoints/stylesheets/conflicts.scss";
import "~/entrypoints/stylesheets/fontello.scss";
import "~/entrypoints/stylesheets/form_fields.scss";
import "~/entrypoints/stylesheets/layout.scss";
import "~/entrypoints/stylesheets/login.scss";
import "~/entrypoints/stylesheets/main_index.scss";
import "~/entrypoints/stylesheets/reports.scss";
import "~/entrypoints/stylesheets/uswds.css";

import "@uswds/uswds/css/uswds.min.css";
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()

//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheetsheet in app/frontend/index.css
// import '~/index.css'

const tokenDom = document.querySelector("meta[name=csrf-token]");
var standard_headers = {};
if (tokenDom) {
  const csrfToken = tokenDom.content;
  standard_headers = { "X-CSRF-Token": csrfToken };
}
